module.exports = __webpack_public_path__ + "static/media/CorePartners_LogoRGB_negativo.30173af1.png";